<div class="formfield">
  <div class="nes-flex nes-flex-col" [formGroup]="formDate" (focusout)="onBirthDateBlur()">
    <nes-text class="nes-mb-1" weight="bold" color="blue" size="md">
      {{ 'USER_DATA.INPUT.BIRTH_DATE.LABEL' | translate }}
    </nes-text>
    <nes-text size="sm" class="nes-mb-3 birth-date-info-text">
      {{ 'USER_DATA.INPUT.BIRTH_DATE.INFO_TEXT' | translate }}
    </nes-text>
    <nes-date-input
      #birthDateInput
      [name]="'USER_DATA.INPUT.BIRTH_DATE.LABEL' | translate"
      [dayValue]="formDate.get('birthDate')!.value?.split('-')[0]"
      [monthValue]="formDate.get('birthDate')!.value?.split('-')[1]"
      [yearValue]="formDate.get('birthDate')!.value?.split('-')[2]"
      [cypress]="'birth_date'"
      [error]="getCombinedError()"
      formControlName="birthDate"
      nesFormControl
      controlled
      nes-id="birthDate"
      id="birthDate"
      hidden-label
      required
      (nesOnChange)="onKeyup($event)"
    ></nes-date-input>
  </div>
</div>
